import {
  Component,
  OnInit,
  signal,
  ChangeDetectionStrategy,
} from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

const COOKIE_CONSENT_KEY = 'myplace_cookie_consent';

@Component({
  selector: 'app-cookie-consent',
  standalone: true,
  imports: [CommonModule, RouterLink, TranslateModule],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    @if (visible()) {
      <div
        class="fixed bottom-0 left-0 right-0 z-50 p-4 bg-white dark:bg-gray-900 border-t border-gray-200 dark:border-gray-700 shadow-2xl"
      >
        <div
          class="max-w-5xl mx-auto flex flex-col sm:flex-row items-start sm:items-center gap-4"
        >
          <div class="flex-1 text-sm text-gray-700 dark:text-gray-300">
            <p>
              {{ 'COOKIE_CONSENT.DESCRIPTION' | translate }}
              <a
                routerLink="/privacy"
                class="text-blue-600 dark:text-blue-400 underline"
                >{{ 'COOKIE_CONSENT.PRIVACY_LINK' | translate }}</a
              >.
            </p>
          </div>
          <div class="flex gap-3 shrink-0">
            <button
              (click)="reject()"
              class="px-4 py-2 text-sm text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white border border-gray-300 dark:border-gray-600 rounded-lg transition-colors cursor-pointer"
            >
              {{ 'COOKIE_CONSENT.REJECT' | translate }}
            </button>
            <button
              (click)="accept()"
              class="px-4 py-2 text-sm text-white bg-blue-600 hover:bg-blue-700 rounded-lg transition-colors cursor-pointer font-medium"
            >
              {{ 'COOKIE_CONSENT.ACCEPT' | translate }}
            </button>
          </div>
        </div>
      </div>
    }
  `,
})
export class CookieConsentComponent implements OnInit {
  private platformId = inject(PLATFORM_ID);
  visible = signal(false);

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      const stored = localStorage.getItem(COOKIE_CONSENT_KEY);
      if (!stored) {
        this.visible.set(true);
      }
    }
  }

  accept() {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem(COOKIE_CONSENT_KEY, 'accepted');
    }
    this.visible.set(false);
  }

  reject() {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem(COOKIE_CONSENT_KEY, 'rejected');
    }
    this.visible.set(false);
  }
}
